import { render, staticRenderFns } from "./CustomsDocs.vue?vue&type=template&id=07481bc1&scoped=true"
import script from "./CustomsDocs.vue?vue&type=script&lang=js"
export * from "./CustomsDocs.vue?vue&type=script&lang=js"
import style0 from "./CustomsDocs.vue?vue&type=style&index=0&id=07481bc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07481bc1",
  null
  
)

export default component.exports